import {
  CommonCriteria,
  PageRequest,
  PaginationResponseType,
  ProductType,
  ResponseType,
} from '@/types';
import { axios, get, post, put } from './baseAxios';
import { API_PRODUCT } from './urls';

const url = API_PRODUCT;

const create = (request: ProductType): Promise<ResponseType<ProductType>> =>
  post(`${url}`, request);

const update = (id: number, request: ProductType): Promise<ResponseType<ProductType>> =>
  put(`${url}/${id}`, request);

const deleteById = (id: number): Promise<ResponseType<boolean>> => axios.delete(`${url}/${id}`);

const getById = (id: number): Promise<ResponseType<ProductType>> => get(`${url}/${id}`);

const filter = (
  request: PageRequest & CommonCriteria
): Promise<PaginationResponseType<ProductType[]>> => get(`${url}`, { params: { ...request } });

const syncProducts = (request: ProductType[]): Promise<ResponseType<boolean>> =>
  post(`${url}/sync`, request);

export { create, deleteById, filter, getById, update, syncProducts };
